import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchAll'
})
export class SearchAllPipe implements PipeTransform {
  transform(dataArray: any[], dataSearch: any ,filter:string, id:string='all'): any[] {  
    if(dataArray!=null && dataArray!=undefined ){
      let dataSearchKeys = Object.keys(dataSearch);
      if(filter!='all'){
        if(filter!=id){
          return [];
        }
      }
      return dataArray.filter( (item) =>{
        return dataSearchKeys.some((keyName) =>{
          return new RegExp(removeAccents(dataSearch[keyName].toLowerCase()),'gi').test(removeAccents(item[keyName]?.toLowerCase())) || dataSearch[keyName] === "";
        });
      });
    }
    return [];
  }
}

const removeAccents = (str) => {
  if(str != null && str != undefined){
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
}
